import { FinancialAgencyServices } from '@recoil_iqfu/atoms/auth/financialAgencyLoginUserData';

//Literal Typeのみ定数として扱う
export type UserType = 'admin' | 'company' | 'financial_agency';
export type consoleUserType = 'admin' | 'company' | 'financial_agency';
export type AdminUserRole = keyof typeof AdminUserRoleText;
export type OutsourcerPermissionCodes = keyof typeof OutsourcerPermissionCodesText;
export type FloorPlanRadioType = 'input' | 'other' | 'unknown';

export const postalRegex: RegExp = /^$|^\d{7}$|^\d{3}-\d{4}$/;
export const emailRegex: RegExp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z]{1,}$/;
export const emailRegexWithEmptyString: RegExp =
  /^$|^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z]{1,}$/;
export const floatNumberRegex: RegExp = /^([1-9]\d*|0)(\.\d{1,4})?$/;
export const integerNumberRegex: RegExp = /^[0-9]*$/;
export const imageFileRegex: RegExp = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i;

export const consumptionTax = 1.1;

export const DefaultIqraLatLong = { lat: 34.724, long: 135.5 };

export const AdminUserRoleText = {
  master: 'マスター',
  manager: 'マネージャー',
  member: 'メンバー',
  sales_member: '営業メンバー',
  outsourcer: '業務委託',
};

export const OutsourcerPermissionCodesText = {
  iqra_cloud: 'イクラウド入力',
  sale_case_csv: 'CSV整形',
  sale_case_approval: '実績承認',
};

export const MediaQuery = {
  ssm: '(max-width:375px)',
  sm: '(max-width:576px)',
  md: '(max-width:768px)',
  lg: '(max-width:992px)',
  xl: '(max-width:1239px)',
};

export const MediaQueryMin = {
  ssm: '(min-width:375px)',
  sm: '(min-width:576px)',
  md: '(min-width:768px)',
  lg: '(min-width:992px)',
  xl: '(min-width:1239px)',
};

const memberAndSalesMemberMenuList = [
  'dashboard',
  'cs_tools',
  'company',
  'sale_cases',
  'seller_company_review',
  'announcements',
  'mansion',
  'city',
  'town',
  'contents_csv',
  'talk',
  'properties',
  'seller',
  'offline_seller_users',
  'company_contact',
  'seller_contact',
  'selling_consultations',
  'financial_agency_contact',
  'financial_agency_company_consulting',
  'seller_financial_agency_consulting',
  'seller_company_contact',
  'agreement_reports',
  'referral_sellers',
  'registered_leaseback_sellers',
  'iqra_cloud/top',
  'iqra_cloud/list',
  'iqra_cloud/upload',
  'iqra_cloud/company',
  'iqra_cloud/map',
  'nospare_simulator',
  'selling_lp_form',
  'selling_lp_content',
  'existing_seller_reports',
  'seller_surveys',
  'ai_appraisal_report',
  'visit_reservation_bookings',
  'visit_appraisal_reservations',
  'video_consultations',
  'seller_contract_reports',
];

export const availableMenuList: {
  [key in 'master' | 'manager' | 'member' | 'sales_member']: string[];
} = {
  master: [
    'dashboard',
    'cs_tools',
    'prompt_management',
    'company',
    'penalty_applications',
    'sale_cases',
    'seller_company_review',
    'announcements',
    'mansion',
    'city',
    'town',
    'contents_csv',
    'account',
    'talk',
    'properties',
    'seller',
    'offline_seller_users',
    'company_contact',
    'seller_contact',
    'selling_consultations',
    'financial_agency_contact',
    'financial_agency_company_consulting',
    'seller_financial_agency_consulting',
    'seller_company_contact',
    'referral_sellers',
    'agreement_reports',
    'registered_leaseback_sellers',
    'iqra_cloud/top',
    'iqra_cloud/list',
    'iqra_cloud/upload',
    'iqra_cloud/company',
    'iqra_cloud/map',
    'nospare_simulator',
    'selling_lp_form',
    'selling_lp_content',
    'ai_appraisal_report',
    'existing_seller_reports',
    'seller_surveys',
    'visit_reservation_bookings',
    'visit_appraisal_reservations',
    'video_consultations',
    'seller_contract_reports',
    'multi_company_user',
    'user_voice_settings',
  ],
  manager: [
    'dashboard',
    'cs_tools',
    'prompt_management',
    'company',
    'penalty_applications',
    'sale_cases',
    'seller_company_review',
    'announcements',
    'mansion',
    'city',
    'town',
    'contents_csv',
    'talk',
    'properties',
    'seller',
    'offline_seller_users',
    'company_contact',
    'seller_contact',
    'selling_consultations',
    'financial_agency_contact',
    'financial_agency_company_consulting',
    'seller_financial_agency_consulting',
    'seller_company_contact',
    'agreement_reports',
    'referral_sellers',
    'registered_leaseback_sellers',
    'iqra_cloud/top',
    'iqra_cloud/list',
    'iqra_cloud/upload',
    'iqra_cloud/company',
    'iqra_cloud/map',
    'nospare_simulator',
    'selling_lp_form',
    'selling_lp_content',
    'ai_appraisal_report',
    'existing_seller_reports',
    'seller_surveys',
    'visit_reservation_bookings',
    'visit_appraisal_reservations',
    'video_consultations',
    'seller_contract_reports',
    'user_voice_settings',
  ],
  member: [...memberAndSalesMemberMenuList, 'penalty_applications', 'user_voice_settings', 'prompt_management'],
  sales_member: [...memberAndSalesMemberMenuList, 'user_voice_settings', 'prompt_management'],
};

export const outsourcerAvailableMenuList: {
  [key in OutsourcerPermissionCodes]: string[];
} = {
  iqra_cloud: ['iqra_cloud/top', 'iqra_cloud/list'],
  sale_case_csv: ['city', 'town', 'mansion'],
  sale_case_approval: ['sale_cases'],
};

//アクセス不可のpath
export const adminRoleBaseRestrictedRoutes: {
  [key in Exclude<AdminUserRole, 'outsourcer'>]: string[];
} = {
  master: [],
  manager: ['/console/admin/sale_cases/final_import', '/console/admin/account'],
  member: ['/console/admin/sale_cases/final_import', '/console/admin/contents_csv', '/console/admin/account'],
  sales_member: ['/console/admin/sale_cases/final_import', '/console/admin/contents_csv', '/console/admin/account'],
};

//外注者がpermission_codes別にアクセスできるpath
export const OutsourcerPermittedRoutes: {
  [key in OutsourcerPermissionCodes]: string[];
} = {
  iqra_cloud: [
    '/console/admin/dashboard',
    '/console/admin/iqra_cloud',
    '/console/admin/iqra_cloud/jusetsu/list',
    '/console/admin/iqra_cloud/jusetsu/edit/[jusetsu_id]',
    '/console/admin/iqra_cloud/jusetsu/outsourcer/[jusetsu_id]',
  ],
  sale_case_csv: ['/console/admin/dashboard', '/console/admin/city', '/console/admin/town', '/console/admin/mansion'],
  sale_case_approval: [
    '/console/admin/dashboard',
    '/console/admin/sale_cases',
    '/console/admin/sale_cases/[sale_case_id]',
  ],
};

//サービス持っていないときに下記のpathでstarts_withするパスにアクセスするとリダイレクトする
export const FinancialAgencyPermittedRoutes: {
  [key in FinancialAgencyServices]: string[];
} = {
  leaseback: ['/console/financial_agency/chat/consulting', '/console/financial_agency/chat/seller_consulting'],
  refer_seller: ['/console/financial_agency/chat/referral_sellers'],
  pro: ['/console/financial_agency/iqfu_pro'],
};

const MapZoomList = [
  { 北海道: 7 },
  { 青森県: 8 },
  { 岩手県: 8 },
  { 宮城県: 8.5 },
  { 秋田県: 8 },
  { 山形県: 8 },
  { 福島県: 8 },
  { 茨城県: 8 },
  { 栃木県: 8 },
  { 群馬県: 8 },
  { 埼玉県: 9 },
  { 千葉県: 9 },
  { 東京都: 10 },
  { 神奈川県: 9.5 },
  { 新潟県: 8 },
  { 富山県: 8 },
  { 石川県: 8.5 },
  { 福井県: 8.5 },
  { 山梨県: 8 },
  { 長野県: 8 },
  { 岐阜県: 9 },
  { 静岡県: 8.5 },
  { 愛知県: 9 },
  { 三重県: 8.5 },
  { 滋賀県: 9 },
  { 京都府: 9 },
  { 大阪府: 10 },
  { 兵庫県: 9 },
  { 奈良県: 9 },
  { 和歌山県: 8 },
  { 鳥取県: 9 },
  { 島根県: 8 },
  { 岡山県: 8.5 },
  { 広島県: 8.5 },
  { 山口県: 8.5 },
  { 徳島県: 8 },
  { 香川県: 9 },
  { 愛媛県: 9 },
  { 高知県: 8.5 },
  { 福岡県: 9 },
  { 佐賀県: 9.5 },
  { 長崎県: 9.5 },
  { 熊本県: 8 },
  { 大分県: 8.5 },
  { 宮崎県: 8.5 },
  { 鹿児島県: 8.5 },
  { 沖縄県: 9 },
];

export const zoomRate = (prefectureCode: string) => Object.values(MapZoomList[Number(prefectureCode) - 1])[0];

export const CompanyMembershipStatus = {
  active: '加盟中',
  suspended: '休止中',
  pre_discarded: '解約（売主対応あり）',
  discarded: '完全解約',
} as const;

export const CompanyMembershipActionLabels = {
  suspend: '休止',
  reactivate: '休止解除',
  pre_discard: '解約（売主対応あり）',
  discard: '完全解約',
} as const;
